export class BfxFindNewFavoriteActionEvent {
  constructor(callback: any, reset: boolean, service: any) {
    this._callback = callback;
    this._reset = reset;
    this._service = service;
  }
  public _callback: any;
  public _reset: boolean;
  public _service: any;
}
